import React from 'react';
import { Link } from 'react-router-dom';
import { ListGroup, Container, Row, Col, Navbar, Nav } from 'react-bootstrap';

const Devices = () => {
  return (
    <Container fluid>
      <h2>Devices</h2>
    </Container>
  );
};

export default Devices;
